var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.649,
    height: 119.934,
    viewBox: "0 0 120.649 119.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_2_",
    "data-name": "email (2)",
    transform: "translate(0 -1.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M244.511,326.484l-20.5,25.216,33.7-19.56Z",
    transform: "translate(-171.222 -248.391)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(0 1.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M168.006,2.228a3.773,3.773,0,0,0-3.687-.407L66.292,47.064a3.765,3.765,0,0,0-.09,6.884l90.486,45.243a3.833,3.833,0,0,0,1.576.347,3.728,3.728,0,0,0,1.9-.513,3.773,3.773,0,0,0,1.855-2.941L169.56,5.6A3.744,3.744,0,0,0,168.006,2.228Z",
    transform: "translate(-48.924 -1.518)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M176.685,459.109a3.77,3.77,0,0,1-1.651-7.163A12.266,12.266,0,0,0,178,450.12a3.436,3.436,0,0,1,4.66-1.908,4.059,4.059,0,0,1,2.051,5.173c-.249.686-1.018,2.752-6.394,5.354A3.775,3.775,0,0,1,176.685,459.109Z",
    transform: "translate(-132.164 -342.742)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M74.3,478.434h-.271a30.5,30.5,0,0,1-12.849-2.692,3.77,3.77,0,1,1,3.159-6.847,22.869,22.869,0,0,0,9.69,2.006,3.89,3.89,0,0,1,3.906,3.77A3.652,3.652,0,0,1,74.3,478.434Z",
    transform: "translate(-45.09 -358.5)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M6.268,414.151a3.785,3.785,0,0,1-3.25-1.847,41.555,41.555,0,0,1-2.745-5.6,3.774,3.774,0,0,1,7-2.828,32.745,32.745,0,0,0,2.24,4.577,3.78,3.78,0,0,1-1.32,5.173A3.9,3.9,0,0,1,6.268,414.151Z",
    transform: "translate(0 -307.27)",
    fill: "#2196f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M288.1,17.492,224.008,86.028v29.491l19.138-20.654Z",
    transform: "translate(-171.222 -12.21)",
    fill: "#64b5f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentIcon);
export default __webpack_public_path__ + "static/media/email-sent-icon.1e2588b7de2896b713574d840bd33cbc.svg";
export { ForwardRef as ReactComponent };